import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-weight-semibold my-5" }, "Registro de Cliente")
], -1)
const _hoisted_4 = { class: "col-12 col-md-8" }
const _hoisted_5 = { class: "row row-cols-1 row-cols-md-2" }
const _hoisted_6 = { class: "col form-group mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "person"),
  /*#__PURE__*/_createTextVNode(" Nombres:")
], -1)
const _hoisted_8 = { class: "col form-group mb-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "surname",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "person_add"),
  /*#__PURE__*/_createTextVNode(" Apellidos:")
], -1)
const _hoisted_10 = { class: "col form-group mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "phone"),
  /*#__PURE__*/_createTextVNode(" Teléfono:")
], -1)
const _hoisted_12 = { class: "col form-group mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "email"),
  /*#__PURE__*/_createTextVNode(" Correo electrónico:")
], -1)
const _hoisted_14 = { class: "col form-group mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "lock"),
  /*#__PURE__*/_createTextVNode(" Contraseña:")
], -1)
const _hoisted_16 = { class: "col form-group mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmed_password",
  class: "d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons small text-lightgray mr-1" }, "lock"),
  /*#__PURE__*/_createTextVNode(" Confirmar contraseña:")
], -1)
const _hoisted_18 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ml-1",
  for: "promotion"
}, "Autorizo recibir comunicaciones promocionales y autorizo el uso de mi información para fines adicionales.", -1)
const _hoisted_21 = { class: "mb-4" }
const _hoisted_22 = {
  class: "form-check-label ml-1",
  for: "privacy"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Declaro que he leído y acepto las ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Políticas de privacidad")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" y los ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Términos y condiciones")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_28 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  name: "create",
  class: "btn btn-primary btn-rounded w-100"
}, "Completar registro", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-4" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/register/seller" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-100",
      src: "https://tiendaiwari.globoazul.pe/img/template/register-commerce.png",
      alt: ""
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitRegister && _ctx.submitRegister(...args))),
          class: "mb-5",
          action: "/",
          method: "post"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                name: "name",
                id: "name",
                type: "text",
                class: "form-control",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.surname) = $event)),
                name: "attr[surname]",
                id: "surname",
                type: "text",
                class: "form-control",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.surname]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
                name: "attr[phone]",
                id: "phone",
                type: "text",
                class: "form-control",
                autocomplete: "off"
              }, null, 512), [
                [_vModelText, _ctx.phone]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
                name: "email",
                id: "email",
                type: "email",
                class: "form-control",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event)),
                name: "password",
                id: "password",
                type: "password",
                class: "form-control",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.password]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.passwordConfirm) = $event)),
                name: "confirmed_password",
                id: "confirmed_password",
                type: "password",
                class: "form-control",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.passwordConfirm]
              ]),
              (_ctx.messagePassword !== '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.messagePassword), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkAds) = $event)),
              type: "checkbox",
              value: "1",
              id: "promotion",
              name: "attr[ads]"
            }, null, 512), [
              [_vModelCheckbox, _ctx.checkAds]
            ]),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkTerms) = $event)),
              type: "checkbox",
              value: "1",
              id: "privacy",
              name: "attr[accept]",
              required: ""
            }, null, 512), [
              [_vModelCheckbox, _ctx.checkTerms]
            ]),
            _createElementVNode("label", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_router_link, {
                to: "/privacy-policy",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _hoisted_25,
              _createVNode(_component_router_link, {
                to: "/terms-conditions",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              }),
              _hoisted_27
            ])
          ]),
          _hoisted_28
        ], 32)
      ]),
      _hoisted_29
    ])
  ]))
}